<h1 mat-dialog-title>Create a Category</h1>
<div mat-dialog-content>
  <form [formGroup]="category"
    (submit)="onSubmit()">
    <mat-form-field>
      <input matInput
        placeholder="Category Name"
        tabindex="1"
        formControlName="name">
    </mat-form-field>
    <ca-icon-select placeholder="Icon"
      formControlName="icon"></ca-icon-select>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button
    (click)="onSubmit()"
    tabindex="2">Create</button>
  <button mat-button
    (click)="onCancel()"
    tabindex="-1">Cancel</button>
</div>